import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IAndRListService } from '../../services/i-and-rs-list.service';
import { GetIAndRsListPayload } from '../../types/i-and-rs-params';

@Component({
   selector: 'app-i-and-rs-list-toolbar',
   templateUrl: './i-and-rs-list-toolbar.component.html',
   styleUrls: ['./i-and-rs-list-toolbar.component.scss']
})
export class IAndRListToolbarComponent implements OnInit {
   private _activeOnly: boolean;
   @Input() payload: GetIAndRsListPayload;
   @Input()
   get activeOnly(): boolean {
      return this._activeOnly;
   }
   set activeOnly(value: boolean) {
      this._activeOnly = value;
      this.setActiveOnlyText()
   }
   @Output() addIAndR = new EventEmitter();
   @Output() searchChange = new EventEmitter<string>();
   @Output() activeOnlyChange = new EventEmitter<boolean>();
   @Output() toggleChange = new EventEmitter<boolean>();

   toggle: boolean = false;
   activeOnlyText: string;

   constructor(
      private service: IAndRListService
   ) { }

   ngOnInit(): void {
      this.searchChange.emit(null)
   }

   export = () => {
      this.service.getIAndRExport(this.payload).subscribe();
   }

   activeOnlyToggle() {
      this.activeOnly = !this.activeOnly;
      this.activeOnlyChange.emit(this.activeOnly);
   }

   setActiveOnlyText() {
      this.activeOnlyText = this.activeOnly ? 'Click to include Inactive I&Rs' : 'Click to exclude Inactive I&Rs'
   }

   onToggle() {
      this.toggle = !this.toggle;
      this.toggleChange.emit(this.toggle);
   }
}